<template>
        <v-form v-model="valid" ref="i_platform_form">
            <span v-for="(platform,idxPlat) in platforms" v-bind:key="idxPlat">
                <v-card class="ma-0 pa-0 mb-2 elevation-1">
                    <v-card-text class="ma-0 px-0 py-2">
                        <div class="d-flex flex-column">
                            <div v-if="isMultifunction()">    
                                <v-autocomplete dense outlined
                                    label="famiglia*"
                                    v-model="platform.family"
                                    :items="Object.values(families_obj).filter(f => { return f.enabled && id!='multifunzione' })"
                                    item-text="label"
                                    item-value="id"
                                    :rules="[rules.mandatory]"
                                ></v-autocomplete>
                            </div>
                            <div v-if="!!platform.family">
                                <v-container>
                                <v-row no-gutters>
                                    <v-col cols="6">
                                        <v-text-field dense outlined
                                            v-model="platform.name"
                                            label="matricola dispositivo"
                                        ></v-text-field>
                                    </v-col>
                                    <v-col cols="5" class="pl-2">
                                        <v-autocomplete dense outlined
                                            ref="UOMS"
                                            label="unità di misura*"
                                            :items="families_obj[platform.family].uoms"
                                            item-value="id"
                                            :rules="[rules.mandatory]"
                                            v-model="platform.uom"
                                            @change="searchCategories(platform)">
                                        </v-autocomplete>
                                    </v-col>
                                    <v-col cols="1"
                                        style="min-width: 24px; max-width:48px"
                                        class="flex-grow-0 flex-shrink-1">
                                        <v-btn fab absolute color="primary" float-right top style="top: -6px; right: -4px;" class="text-right">
                                        <v-badge :content="idxPlat + 1">
                                            <v-icon large>layers</v-icon>
                                        </v-badge>
                                        </v-btn>
                                    </v-col>
                                </v-row>
                                <v-row no-gutters>
                                    <v-col cols="6"
                                        style="max-width: 80%;"
                                        class="flex-grow-md-1 flex-shrink-md-0">
                                        <v-autocomplete dense outlined
                                            label="set di prove"
                                            :items="categories[platform.id]"
                                            item-value="_id"
                                            item-text="name"
                                            v-model="platform.category"
                                            clearable
                                        >
                                        </v-autocomplete>
                                    </v-col>
                                    <v-col col="5" class="pl-2"
                                        v-if="!!families_obj[platform.family].class && families_obj[platform.family].class.length>0">
                                        <v-autocomplete dense outlined
                                            label="classe omologazione(*VP)"
                                            :items="families_obj[platform.family].class"
                                            item-value="id"
                                            v-model="platform.instrument_class"
                                            :rules="[rules.mandatoryNullReportRules(platform.instrument_class, 'leg', selected_reports)]"
                                            @change="updatePlatRanges(platform)"
                                        >
                                        </v-autocomplete>
                                    </v-col>
                                    <v-col v-if="platform.category" cols="12">
                                        <CategoryDesc 
                                            :category_id="platform.category" />
                                    </v-col>
                                </v-row>
                                </v-container>
                                <CustomData v-if="platform.custom_data" 
                                    :o_data="platform.custom_data"
                                    :family="platform.family"
                                    :selected_reports="selected_reports"
                                    :uom="platform.uom"
                                    :is_multirange="checkMultirange(platform)"
                                    :c_type="'object'"
                                    ref="custom_data"/>

                                <!-- TO BE MOVED IN COMPONENT -->
                                <div class="d-flex pl-2">
                                    <div class="d-flex align-start justify-start flex-grow-1 flex-shrink-0">
                                        <b class="font-italic">Campo di misura</b>
                                    </div>
                                    <div class="d-flex align-start justify-center flex-grow-0 flex-shrink-1 pr-2">
                                        <v-btn text @click="addRange(platform)" ma-4><v-icon small class="pa-2">add_box</v-icon>range</v-btn>
                                    </div>
                                </div>
                                <v-container>
                                    <v-row v-for="(range,idxRange) in platform.ranges" v-bind:key="'range_'+idxRange">
                                    <v-col cols="12" md="1" class="py-0 flex-xs-grow-1 flex-xs-shrink-0 flex-md-shrink-1 flex-md-grow-0 order-xs-1 order-md-2">
                                        <v-btn v-if="idxRange>0" fab small class="float-right">
                                            <v-icon @click="removeRange(platform, idxRange)" >delete</v-icon></v-btn>
                                    </v-col>
                                    <v-col cols="12" md="11" class="py-md-0 py-sm-1 d-flex flex-row align-start flex-grow-1 flex-shrink-0 order-xs-2 order-md-1">
                                            <NumericField dense outlined
                                                label="minimo*"
                                                v-model="range.min"
                                                :max="range.max"
                                                :negative="isNegativeValue(platform)"
                                                :rules="[rules.mandatory]"
                                                :suffix="platform.uom"
                                                placeholder="0"
                                            ></NumericField>
                                            <NumericField dense outlined
                                                class="pl-2"
                                                label="massimo*"
                                                :min="range.min"
                                                v-model="range.max"
                                                :rules="[rules.mandatory]"
                                                :suffix="platform.uom"
                                                placeholder="0"
                                            ></NumericField>
                                            <NumericField dense outlined
                                                class="pl-2"
                                                label="risoluzione*"
                                                @change="calcDigits(platform)"
                                                v-model="range.d"
                                                :max="range.e"
                                                :rules="[rules.mandatory]"
                                                :suffix="platform.uom"
                                                :key="range.e"
                                                placeholder="0"
                                            ></NumericField>       
                                            <NumericField dense outlined
                                                class="pl-2"
                                                v-if="platform.instrument_class > 0"
                                                label="risoluzione omologata(e)"
                                                v-model="range.e"
                                                :rules="[rules.mandatory]"
                                                :suffix="platform.uom"
                                                placeholder="0"
                                                @input="calcResolution(platform, range)"
                                            ></NumericField>       
                                    </v-col>
                                    <v-divider v-if="idxRange>0 || (idxRange==0 && platform.ranges.length!=1)"></v-divider>
                                    </v-row>
                                </v-container>


                                <!-- TO BE MOVED IN COMPONENT -->
                                 <!--
                                <div class="d-flex pl-2">
                                    <div class="d-flex align-start justify-start flex-grow-1 flex-shrink-0">
                                        <b class="font-italic">Tolleranza (ISO*/ISO Semplificata*)</b>
                                    </div>
                                    <div class="d-flex align-start justify-center flex-grow-0 flex-shrink-1 pr-2">
                                        <v-btn text @click="addTolerance(platform)"><v-icon small class="pa-2">add_box</v-icon>tolleranza</v-btn>
                                    </div>
                                </div>
                                <v-alert :value="!checkTolerance(platform)" :key="selected_reports.length" type="warning">
                                    Valori di tolleranza richiesti per effettuare i report
                                </v-alert>
                                <v-container>
                                    <v-row v-for="(tolerance,idxTol) in platform.tolerance" v-bind:key="'tol_'+idxTol">
                                    <v-col cols="12" md="1" class="py-0 flex-xs-grow-1 flex-xs-shrink-0 flex-md-shrink-1 flex-md-grow-0 order-xs-1 order-md-2">
                                        <v-btn fab small class="float-right">
                                            <v-icon @click="removeTolerance(platform, idxTol)" >delete</v-icon></v-btn>
                                    </v-col>
                                    <v-col cols="12" md="11" class="py-md-0 py-sm-1 d-flex order-xs-2 order-md-1">                     
                                        <v-container class="pa-0 ma-0">
                                            <v-row no-gutters>
                                                <v-col cols="6">
                                                    <v-autocomplete dense outlined
                                                        label="tipo tolleranza*"
                                                        v-model="tolerance.t_type"
                                                        :items="filterToleranceType(platform.family)"
                                                        item-text="text"
                                                        item-value="id"
                                                        :rules="[rules.mandatory]"
                                                    ></v-autocomplete>
                                                </v-col>
                                                <v-col cols="6" class="pl-2 d-flex align-content-end justify-center" v-if="tolerance.t_type && tolerance.t_type!='law'">
                                                    <v-radio-group class="my-0" row dense outlined v-model="tolerance.value" @change="buildToleranceValues(tolerance, families_obj[platform.family].tolerance)" :rules="[rules.mandatory]">
                                                        <v-radio dense label="tolleranza unica" value="unique"></v-radio>
                                                        <v-radio dense label="tolleranze standard" value="instrument" v-if="!!families_obj[platform.family].tolerance && families_obj[platform.family].tolerance.length > 0"></v-radio>
                                                    </v-radio-group>
                                                </v-col>
                                            </v-row>
                                            <div v-if="tolerance.t_type!='law'">
                                            <v-row  no-gutters v-for="key of tolerance.t_vals" :key="key.test_type">
                                                <v-col cols="4" class="align-center text-right">
                                                    <span v-if="tolerance.value != 'unique'">{{tol_instr_type[platform.family][key.test_type]}}</span>
                                                </v-col>
                                                <v-col cols="4">
                                                    <NumericField dense outlined
                                                        class="pl-2"
                                                        label="valore*"
                                                        v-model="key.t_val"
                                                        :precision="tolerancePrecision(key)"
                                                        :rules="[rules.mandatory]"
                                                        placeholder="0"
                                                    ></NumericField>       
                                                </v-col>
                                                <v-col cols="4">
                                                    <v-autocomplete dense outlined
                                                        class="pl-2"
                                                        label="tipologia*"
                                                        v-model="key.t_calc"
                                                        :items="filterToleranceCalc(platform.family)"
                                                        :rules="[rules.mandatory]"
                                                        item-text="text"
                                                        item-value="id"
                                                    ></v-autocomplete>
                                                </v-col>
                                                
                                            </v-row>
                                            </div>
                                        </v-container>
                                    </v-col>
                                    <v-divider v-if="idxTol>0 || (idxTol==0 && platform.tolerance.length!=1)"></v-divider>
                                    </v-row>
                                </v-container>
                                -->
                            </div>
                            <div class="d-flex align-start justify-end flex-grow-0 flex-shrink-1 pr-2">
                                <v-btn v-if="idxPlat>0" text @click="removePlatform(idxPlat)"><v-icon small class="pa-2">delete</v-icon> dispositivo</v-btn>
                            </div>
                        </div>
                        </v-card-text>
                    </v-card>
            </span>
        </v-form>
</template>

<script>
import {getModel} from '../../../utils/model'
import {f_rules} from '../../../utils/commonUtils'
// import {Platform,Range} from '../../../utils/objectSchema'
import {i_families, report_type, tolerance} from "../../../utils/common.js"
import CustomData from "./CustomData"
import CategoryDesc from "../CategoryDesc"
import Big from "big.js"
// import _ from 'lodash'

export default {
    components: { CustomData, CategoryDesc },
    props: {
        family: {
            type: String,
            required: true
        },
        init_platforms: {
            type: Array,
            required: false,
            default: []
        },
        selected_reports: {
            type: Array,
            required: false,
            default: []
        },
        print: {
            type: Boolean,
            required: false,
            default: false
        }
    },
    data() {
        return {
            platforms: [],
            rules: f_rules,
            class_array: [], //class_family,
            resolutions: [],
            valid: false,
            families: [],
            tolerance_dict: tolerance,
            pl_validity: {},
            op_types: [],
            categories: {},
            tol_instr_type: {}
        }
    },
    methods: {
        checkMultirange(platform){
            if(platform && platform.ranges.length > 1){
                return true
            } else {
                return false
            }
        },
        async buildAllCategories(){
            this.categories = {}
            for(let plat of this.platforms){
                await this.searchCategories(plat)
            }
            console.log("finished building categories", this.categories)
        },
        async searchCategories(platform){
            let selector = {
                doc_type: "category",
                family: platform.family,
                uom: platform.uom
            }
            let res = await this.$store.state.$pouch.find("masters", {selector: selector, fields: ['_id', 'name']})
            if(res.docs){
                this.$set(this.categories, platform.id, res.docs)
            }
        },
        buildToleranceValues(tolerance, platformTolerances){
            console.log("$$ DEBUG TOLERANCE", tolerance, platformTolerances)
            tolerance.t_vals = []
            if(tolerance.value === "unique"){
                let item = {
                    test_type: "unique",
                    t_calc: "val",
                    t_val: null
                }
                console.log("$$ debug, built unique")
                tolerance.t_vals.push(item)
            } else if (tolerance.value === "instrument" && platformTolerances != undefined){
                for(let tol of platformTolerances){
                    let item = {
                        test_type: tol,
                        t_calc: "val",
                        t_val: null
                    }
                    console.log("$$ debug, built", tol)
                    tolerance.t_vals.push(item)
                }
            }
        },
        isMultifunction() {
            if(this.families_obj[this.family]!=undefined){
                return this.families_obj[this.family].multifunction
            }
            return false
        },
        assignFamilyPlat() {
            for (let plat of this.platforms) {
                console.log('platform:', plat)
                if (this.isMultifunction()) {
                    plat.family = null
                    plat.uoms = null
                } else {
                    plat.family = this.family
                }
            }
        },
        reset(){
            this.platforms = []
            this.addPlatform()
        },
        addRange(platform){
            let Range = getModel("Range");
            platform.ranges.push(Range());
        },
        removeRange(platform, rIndex){
           platform.ranges.splice(rIndex, 1);
        },
        addTolerance(platform){
            let Tolerance = getModel("Tolerance");
            let tol = Tolerance()
            if(platform.family == "dosatore additivi litri" || platform.family == "sonda umidità"){
                tol.t_type = "manifacturer"
                tol.value = "instrument"
                this.buildToleranceValues(tol, this.families_obj[platform.family].tolerance)
                tol.t_vals[0].t_calc = platform.family == "dosatore additivi litri" ? 'perc' : 'val'
                tol.t_vals[0].t_val = "1"
            }
            platform.tolerance.push(tol);
        },
        removeTolerance(platform, tIndex){
           platform.tolerance.splice(tIndex, 1);
        },
        
        addPlatform(){
            let Platform = getModel("Platform");
            let Range = getModel("Range");
            let p_family = this.family
            if (this.isMultifunction()) {
                p_family = ""
            }
            let range = Range()
            console.log("range", range)
            let plat = Platform({
                id: new Date().getTime().toString(),
                family: p_family, 
                ranges: [range],
                tolerance: []
            })
            if(this.family == "dosatore additivi litri" || this.family == "sonda umidità"){
                this.addTolerance(plat)
            }
            this.platforms.push(plat)
        },
        validate() {
            this.$refs.i_platform_form.validate()
        },
        removePlatform(pIndex){
           this.platforms.splice(pIndex, 1);
        },
        getPlatforms(){
            for(let pidx in this.platforms) {
                if(this.$refs.custom_data){
                    this.platforms[pidx].custom_data = _.cloneDeep(this.$refs.custom_data[pidx].getData())
                    console.log("******* PLATFORM custom data- ", this.platforms[pidx].custom_data)
                }
            }
            return this.platforms
        },
        updatePlatRanges(platform){
            if (platform.instrument_class == 0) {
                for (let range of platform.ranges) {
                    range.e = ""
                }
            }
        },
        checkTolerance(platform){
            let fam  = this.families_obj[platform.family]
            let required = true
            for (let op_type of Object.keys(fam.report)) {
                if (this.selected_reports.includes(op_type) && fam.report[op_type].check && fam.report[op_type].check.platform && fam.report[op_type].check.platform.length > 0 && fam.report[op_type].check.platform.includes('tolerance')) {
                    required = required && platform.tolerance.length>0
                }
            }
            return required
        },
        getPlatformsValidity() {
            this.pl_validity = Object.assign({}, ...this.op_types.map(s => ({[s]: true})))
            for(let pidx in this.platforms) {
                let fam  = this.families_obj[this.platforms[pidx].family]
                for (let op_type of Object.keys(fam.report)) {
                    if (!this.pl_validity[op_type]) {
                        break
                    }
                    if (fam.report[op_type].check && fam.report[op_type].check.platform && fam.report[op_type].check.platform.length > 0) {
                        for (let check of fam.report[op_type].check.platform) {
                            console.log('$$ platform check', op_type, pidx, check)
                            let l_valid = false
                            switch(check ){
                                case 'custom_data':
                                    l_valid = this.$refs.custom_data[pidx].isValid()
                                    break
                                case 'tolerance':
                                    l_valid = this.platforms[pidx].tolerance.length>0
                                    break
                                case 'instrument_class':
                                    l_valid = this.platforms[pidx].instrument_class>0
                                    break
                                default:
                                    break
                            }
                            console.log("$$ CHECK", op_type, check, l_valid)
                            if (!l_valid) {
                                this.pl_validity[op_type] = false
                                break
                            }
                        }
                    }
                console.log('OP TYPE', op_type)
                }

            }
            console.log("$$ platform validity pippo", this.pl_validity)
            return this.pl_validity

        },
        // TODO trovare un modo migliore per fare il parsing dei numeri, magari interno all'operazione stessa del textfield
        calcDivs(item, range){
            switch(item){
                case 'max_c': 
                    if(range.e != null && range.e > 0 && range.max > 0){
                        range.div_nr = Big(range.max).div(range.e).toString()
                    } 
                    break;
                default: 
                    console.log("something went wrong")
            }
        },
        calcDigits(platform){
            let min = platform.ranges.reduce((acc, val) => {
                acc = ( acc === undefined || val.d < acc ) ? val.d : acc
                return acc;
            }, Number.POSITIVE_INFINITY)
            console.log("minimum: ", min)
            platform.digits = this.countDecimals(min)
            console.log("platform digits",platform.digits)
        },
        countDecimals(value) {
            if(value != null && value != undefined){
                if(Math.floor(value) === value) return 0;
                let split = value.toString().split(".")
                if(split.length > 1){
                    return split[1].length
                } else {
                    return 0
                }
            }
        },
        isNegativeValue(platform){
            return i_families[platform.family].negativeMin
        },
        filterToleranceType(family) {
            let ttype = _.filter(this.tolerance_dict._type, function(item) {
                if (item.id == 'law') {
                    if ( !['phmetro', 'termometro', 'manometro', 'dosatore additivi litri', 'dosatore additivi', 'sonda umidità'].includes(family) ){
                        return item
                    }
                } else {
                    return item
                }
            });
            console.log(ttype)
            return ttype
        },
        filterToleranceCalc(family){
            let ttype = _.filter(this.tolerance_dict._calc, function(item) {
                if (item.id == 'val') {
                    if ( !['dosatore additivi litri', 'dosatore additivi'].includes(family) ){
                        return item
                    }
                } else if(item.id == "perc") {
                    if ( !['sonda umidità'].includes(family) ){
                        return item
                    }
                } else {
                    return item
                }
            });
            console.log(ttype)
            return ttype
        },
        tolerancePrecision(key){
            if(key.t_calc == "val"){
                return 0
            } else {
                return -1
            }
        },
        checkMinEnabled(platform){
            let families = ['bilancia nawi', 'bilancia nawi meccanica', 'bilancia awi X', 'bilancia awi Y']
            if(families.includes(platform.family)){
                return platform.instrument_class > 0
            } else {
                return true
            }
        },
        calcResolution(platform, range){
            if(platform.instrument_class > 0 && range.e != ""){
                if(platform.family == "bilancia nawi"){
                    let temp = Big(range.e).times(0.1).toString()
                    console.log("$$ changing stuff")
                    this.$set(range, "d", temp)
                } else if(platform.family == "bilancia nawi meccanica"){
                    this.$set(range, "d", range.e)
                }
                this.calcDigits(platform)
            }
        }
    },
    computed: {

    },
    created() {
        this.families_obj = i_families
        this.families = Object.keys(i_families)
        this.families.splice(this.families.indexOf('multifunzione'),1)
        this.op_types = Object.keys(report_type).filter(key => report_type[key].enabled)
    },
    mounted() {
        if (this.init_platforms && this.init_platforms.length>0){
            this.platforms = _.cloneDeep(this.init_platforms)
            this.buildAllCategories()
        } else {
            this.reset()
        }
        this.tol_instr_type = tolerance._instrument_label
        // console.log("finished mounting", this.categories)
        // this.$store.commit('addInstrumentData', this.platforms)    
    },
    updated(){
        this.validate()
    },
    watch: {
        'family': {
            handler() {
                console.log('update platforms family ')
                this.assignFamilyPlat()
                
            }
        },
        'valid':{
            handler() {
                // console.log('$$ platform_validity',  this.valid)
                this.$emit('platform_validity', this.valid)
            }
        }
    }
    }
</script>

<style>

</style>